import styled from 'styled-components';

export const Container = styled.div`
  padding: 30px 20px;
  background: #0a1f30;
  position: relative;
  overflow: hidden;
  z-index: 0;
  &:before {
    content: '';
    display: inline-block;
    width: 215px;
    height: 210px;
    -webkit-transform: rotate(-31deg);
    -ms-transform: rotate(-31deg);
    -webkit-transform: rotate(-31deg);
    -ms-transform: rotate(-31deg);
    transform: rotate(-31deg);
    opacity: 0.14;
    border-radius: 53px;
    background-color: #000000;
    position: absolute;
    left: -109px;
    top: -96px;
    z-index: 0;
  }
  &:after {
    content: '';
    display: inline-block;
    width: 215px;
    height: 210px;
    transform: rotate(-21deg);
    opacity: 0.14;
    border-radius: 56px;
    background-color: #000000;
    position: absolute;
    right: -104px;
    bottom: 0;
    z-index: 0;
  }

  @media (max-width: 1000px) {
    padding: 70px 30px;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  max-width: 1138px;
  padding: 0 15px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  text-align: left;
  flex: 1;
  padding: 0 20px;
  @media (max-width: 602px) {
    text-align: center;
  }
`;

export const Row = styled.div`
  display: grid;
  color: #fff;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(234px, 1fr));
`;

export const Link = styled.a`
  color: #dedede;
  margin-bottom: 8px;
  font-size: 14px;
  text-decoration: none;
  width: fit-content;
  @media (max-width: 602px) {
    margin: auto;
    margin-bottom: 8px;
  }
  &:hover {
    color: #ff9c00;
    transition: 200ms ease-in;
  }
`;

export const Title = styled.p`
  font-size: 18px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: bold;
`;
export const Term = styled.p`
  color: #dedede;
  text-align: center;
  font-size: 13px;
  display: flex;
  gap: 10px;
  padding: 0 10px;
`;

export const SocialIcon = styled.span`
  margin-right: 10px;
`;

export const Divider = styled.div`
  height: 1px;
  background: #e4e4e4;
  margin-top: 30px;
  margin-bottom: 10px;
`;

export const TermWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
`;

export const FooterLogo = styled.div`
  margin: 30px 0 20px 0;
  max-width: 250px;
  img {
    width: 100%;
  }
`;
